import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import userService from "../services/user.service";

export const getFavoriteVideos = createAsyncThunk(
  "favoriteCarrouselVideos/getFavoriteVideos",
  async (queryParams, thunkAPI) => {
    try {
      const response = await userService.getFavoriteVideos(queryParams);
      thunkAPI.dispatch(setMessage(response.data));
      return response.data.details;
    } catch (error) {
      thunkAPI.dispatch(setMessage(error.response));
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const setPage = createAsyncThunk(
  "favoriteCarrouselVideos/setPage",
  async (page, thunkAPI) => {
      return page;
  }
);

const initialState = { videos: [], isFetching: false, isFetched: false, page: 1 };

const favoriteCarrouselVideosSlice = createSlice({
  name: "favoriteCarrouselVideos",
  initialState,
  extraReducers: {
    [getFavoriteVideos.fulfilled]: (state, action) => {
      state.isFetching = false;
      state.isFetched = true;
      state.videos = state.page === 1 ? [...action.payload] : [...state.videos, ...action.payload];
      state.page = state.page + 1;
    },
    [getFavoriteVideos.rejected]: (state, action) => {
      state.isFetching = false;
      state.isFetched = false;
    }
  },
});

const { reducer } = favoriteCarrouselVideosSlice;
export default reducer;
